var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DCDEE1",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.333 28.668H31.333C30.6258 28.668 29.9475 28.9489 29.4474 29.449C28.9473 29.9491 28.6663 30.6274 28.6663 31.3346C28.6663 32.0419 28.9473 32.7202 29.4474 33.2203C29.9475 33.7203 30.6258 34.0013 31.333 34.0013H36.6663C37.3736 34.0013 38.0519 34.2823 38.552 34.7824C39.0521 35.2824 39.333 35.9607 39.333 36.668C39.333 37.3752 39.0521 38.0535 38.552 38.5536C38.0519 39.0537 37.3736 39.3346 36.6663 39.3346H28.6663M33.9997 40.668V27.3346M23.333 20.668V47.3346L25.9997 46.0013L28.6663 47.3346L31.333 46.0013L33.9997 47.3346L36.6663 46.0013L39.333 47.3346L41.9997 46.0013L44.6663 47.3346V20.668L41.9997 22.0013L39.333 20.668L36.6663 22.0013L33.9997 20.668L31.333 22.0013L28.6663 20.668L25.9997 22.0013L23.333 20.668Z",
    stroke: "#E9353C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptIcon);
export default __webpack_public_path__ + "static/media/receipt-icon.57cae8451f3be6f1073b6ea9c830b322.svg";
export { ForwardRef as ReactComponent };